var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg42(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5528 2.82457C11.8343 2.6838 12.1657 2.6838 12.4472 2.82457L20.4472 6.82457C20.786 6.99396 21 7.34022 21 7.71899V17.719C21 18.0978 20.786 18.444 20.4472 18.6134L12.4472 22.6134C12.1657 22.7542 11.8343 22.7542 11.5528 22.6134L3.55279 18.6134C3.214 18.444 3 18.0978 3 17.719V7.71899C3 7.34022 3.214 6.99396 3.55279 6.82457L11.5528 2.82457ZM5 9.33703V17.101L11 20.101V12.337L5 9.33703ZM13 12.337V20.101L19 17.101V9.33703L13 12.337ZM17.7639 7.71899L12 10.601L6.23607 7.71899L12 4.83703L17.7639 7.71899Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg42);
export default __webpack_public_path__ + "static/media/svg42.620ca2fcc574cc8dcc7889db33e45590.svg";
export { ForwardRef as ReactComponent };